import React from "react";
import { List, ShowButton } from "@refinedev/mui";
import { IResourceComponentsProps } from "@refinedev/core";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { InfiniteList } from "components/list/infinity-list";
import { IFundAccount } from "interfaces/fund-account";
import { moneyFormat } from "utils/money-format";

export const ArchivedFundAccountList: React.FC<IResourceComponentsProps> = () => {
  const navigate = useNavigate();

  return (
    <>
      <List
        title="Archived Fund Accounts"
        wrapperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
            padding: 0,
          },
        }}
      >
        <Box>
          <InfiniteList<IFundAccount>
            endpoint="funds"
            limit={5}
            queryParams={{ "orderBy[reference]": "ASC", "status": "ARCHIVED" }}
            isTable={true}
            tableProps={{
              stickyHeader: true,
              headerBgColor: "grey.200",
              responsive: true,
            }}
            columns={[
              {
                field: "fundAccountName",
                header: "Name",
              },
              {
                header: "Type",
                renderCell: function render({ entityInformation }) {
                  return entityInformation ? "Entity" : "Personal";
                },
              },
              {
                header: "Available",
                renderCell: function render({ availableBalance }) {
                  return `$${moneyFormat(availableBalance, 2)}`;
                },
              },
              {
                header: "Total",
                renderCell: function render({ total }) {
                  return `$${moneyFormat(total, 2)}`;
                },
              },
              {
                header: "View",
                renderCell: function render({ fundAccountId }) {
                  return (
                    <>
                      <ShowButton
                        hideText
                        onClick={() =>
                          navigate(`/fund-accounts/show/${fundAccountId}`)
                        }
                      />
                    </>
                  );
                },
              },
            ]}
            searchConfig={{
              enabled: true,
              placeholder: "Search Fund by name...",
              searchField: "searchTerm",
            }}
            emptyMessage={`No Archived Fund found!`}
          />
        </Box>
      </List>
    </>
  );
};
